import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import virtualClassroomStudentRoutes from 'modules/virtualClassrooms/common/routing/studentRoutes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const ParticipantScheduleDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomStudentParticipantScheduleDetails" */ 'modules/virtualClassrooms/student/ParticipantScheduleDetails/pages/ParticipantScheduleDetails'
    )
)

const ParticipantScheduleDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:scheduleId`} component={ParticipantScheduleDetails} />
      <Redirect path='*' to={virtualClassroomStudentRoutes.root} />
    </Switch>
  </Suspense>
)

export default ParticipantScheduleDetailsRouting
